import { render, staticRenderFns } from "./SimpleContent.vue?vue&type=template&id=fd247abe"
import script from "./SimpleContent.vue?vue&type=script&lang=js"
export * from "./SimpleContent.vue?vue&type=script&lang=js"
import style0 from "./SimpleContent.vue?vue&type=style&index=0&id=fd247abe&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports